import * as React from 'react';
import { Box } from '../Box';
import * as styles from './Frame.module.css';

export const Frame = React.forwardRef(function Frame(
  {
    aspectRatio = '1:1',
    children,
    className = '',
    element = 'div',
    height = 'auto',
    maxWidth = 'none',
    padding = 'none',
    style = {},
    width = 'auto',
    ...rest
  },
  ref,
) {
  const combinedClasses = [styles.frame, className].filter(Boolean).join(' ');

  const convertedAspectRatio = aspectRatio.replace(':', '/');

  const combinedStyles = {
    '--aspect-ratio': convertedAspectRatio,
    maxWidth,
    ...style,
  };

  return (
    <Box
      className={combinedClasses}
      element={element}
      height={height}
      padding={padding}
      ref={ref}
      style={combinedStyles}
      width={width}
      {...rest}
    >
      {children}
    </Box>
  );
});
